/**
 * Lightbox decorator script class
 *
 * @package    Decorators
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Lightbox from 'Common/Lightbox';
import Button from 'Common/CustomButtons/Button';

export default lightboxProps => WrappedComponent => {
    return class LightboxDecorator extends PureComponent {
        /**
         * @type {Object}
         */
        static contextTypes = {
            intl: PropTypes.object.isRequired,
        };

        state = {
            isOpen: false,
            handleSubmit: null,
            text: null,
            btnOk: null,
            btnCancel: null,
        };

        /**
         * Handle open lightbox
         *
         * @param handleSubmit
         * @param text
         * @param btnOk
         * @param btnCancel
         */
        handleOpen = (handleSubmit, text, btnOk, btnCancel) => {
            this.setState({
                isOpen: true,
                handleSubmit,
                text,
                btnOk,
                btnCancel,
            });
        };

        /**
         * Handle submit
         */
        handleSubmit = () => {
            const { handleSubmit } = this.state;
            handleSubmit();
            this.handleClose();
        };

        /**
         * Handle close
         */
        handleClose = () => {
            this.setState({
                isOpen: false,
            });
        };

        /**
         * Render
         *
         * @returns {*}
         */
        render() {
            const { isOpen, text, btnOk, btnCancel } = this.state;
            if (text) {
                lightboxProps = {...lightboxProps, text, preFormattedText: true};
            }

            return (
                <Fragment>
                    <WrappedComponent {...this.props} openLightbox={this.handleOpen} />
                    <Lightbox
                        handleClose={this.handleClose}
                        isOpen={isOpen}
                        actions={
                            <Fragment>
                                <Button onClick={this.handleClose} color="danger">
                                    <FormattedMessage id={`button.${btnCancel ? btnCancel : 'no'}`} />
                                </Button>
                                <Button onClick={this.handleSubmit} color="success">
                                    <FormattedMessage id={`button.${btnOk ? btnOk : 'yes'}`} />
                                </Button>
                            </Fragment>
                        }
                        {...lightboxProps}
                    />
                </Fragment>
            );
        }
    };
};



// WEBPACK FOOTER //
// ./src/decorators/lightboxDecorator.jsx